"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaneSet = void 0;
const index_1 = require("../Base/index");
/**
 * Describes a BPMN LaneSet; in essence a collection of lanes.
 */
class LaneSet extends index_1.BaseElement {
    constructor() {
        super(...arguments);
        this.lanes = [];
    }
}
exports.LaneSet = LaneSet;
//# sourceMappingURL=LaneSet.js.map